import { ComponentProps } from "react";
import { Alert as TEUIAlert } from "@timeedit/ui-components";

type TeuiProps = ComponentProps<typeof TEUIAlert>;
type LowercasedSeverity = NonNullable<TeuiProps["type"]>;
type UppercasedSeverity = Uppercase<LowercasedSeverity>;

export type AlertDefaultProps = Omit<TeuiProps, "type"> & {
  severity: UppercasedSeverity;
};

export default function AlertDefault({ ...rest }: AlertDefaultProps) {
  const severity = toValidSeverity(rest.severity);
  return <TEUIAlert type={severity} {...rest} />;
}

function toValidSeverity(value: UppercasedSeverity): LowercasedSeverity {
  switch (value) {
    case "INFO":
      return "info";
    case "WARNING":
      return "warning";
    case "ERROR":
      return "error";
    case "SUCCESS":
      return "success";
    default:
      return "info";
  }
}
